export default __webpack_public_path__ + "static/experienceImg-1120194ea53ea168b0e4c4d977773736.webp";